<template>
  <div>
    <Header>
      <template v-slot:left>
        <FeatherIcon icon="chevron-left" @click="onClickBack" />
      </template>
      アカウント認証
    </Header>
    <div class="account">
      <VerificationAccountStep
        :isLoading="isLoading"
        :user="user"
        :hasBankAccount="hasBankAccount"
      />
      <AppFooter />
    </div>
  </div>
</template>

<script lang="ts">
import { Component, Vue } from "vue-facing-decorator";
import FeatherIcon from "@/components/atoms/other/FeatherIcon.vue";
import Header from "@/components/organisms/common/Header.vue";
import AppFooter from "@/components/organisms/common/AppFooter.vue";
import { ErrorType, showErrorModal } from "@/utils/showErrorModal";
import { authStore } from "@/store/auth";
import { accountService } from "@/app/services/AccountService";
import { salaryService } from "@/app/services/SalaryService";
import VerificationAccountStep from "@/components/organisms/mypage/VerificationAccountStep.vue";

@Component({
  components: {
    FeatherIcon,
    Header,
    AppFooter,
    VerificationAccountStep
  }
})
export default class MypageAccount extends Vue {
  hasBankAccount = false;
  isLoading = false;

  get user() {
    return authStore.user!;
  }

  async created() {
    try {
      this.$loading.show();
      this.isLoading = true;
      // アカウント情報を更新
      await accountService.updateUserData();
      this.hasBankAccount = await salaryService.fetchHasBankAccount();
    } catch (error) {
      showErrorModal(this, error as ErrorType);
    } finally {
      this.$loading.hide();
      this.isLoading = false;
    }
  }

  async onClickBack() {
    await this.$router.push({ name: "Mypage" });
  }
}
</script>

<style lang="scss" scoped>
.account {
  .section {
    // iPhone のノッチ対応
    padding-top: env(safe-area-inset-top, 0);
  }
}
</style>
